import { between, required, shape, stopOnFirstFailure } from '@totalsoft/pure-validations';

export const leasingInterestValidator = shape({
  interestTypeName: required,
  interestTypeCode: required,
  currencyId: required,
  periodicity: [required, between(1, 120)] |> stopOnFirstFailure
});
